export interface TeamMember {
  id: string
  name: string
  role: string
  bio: string
  image: string
  instagram?: string
  email?: string
  candidMoment?: string
  handwrittenNote?: string
  story?: string
  rotation?: string
}

export const teamMembers: TeamMember[] = [
  {
    id: 'isi',
    name: 'Isi',
    role: 'Founder & Visionary',
    candidMoment: 'Perfecting every detail before departure',
    handwrittenNote: 'I turn bold mountain dreams into seamless adventures—fast, safe, unforgettable',
    story: 'A mountain devotee who turns bold ideas into seamless adventures. Hands-on and detail-obsessed, she makes every journey distinctly Apex. Every tiny detail matters when you\'re creating moments that last a lifetime.',
    bio: 'A mountain devotee who turns bold ideas into seamless adventures—fast, safe, and unforgettable. Hands-on and detail-obsessed, she makes every journey distinctly Apex.',
    image: '/images/team/Isi-1920.webp',
    rotation: 'rotate(-2deg)',
    email: 'isi@apexexperience.com'
  },
  {
    id: 'tess',
    name: 'Tess',
    role: 'Skiing Legend',
    candidMoment: 'Carving through fresh powder at La Parva',
    handwrittenNote: '45 years on skis, 5 million vertical feet last season—and I\'m just getting started',
    story: 'She has skied for 45+ years and made 5 million vertical feet last season. Winter base in Mammoth, summer base in La Parva, she chases perpetual winter and delivers relentless mileage. Powerful, precise, and playful—she absolutely rocks on skis.',
    bio: 'She has skied for 45+ years and made 5 million vertical feet last season. Winter base in Mammoth, summer base in La Parva, she chases perpetual winter and delivers relentless mileage. Powerful, precise, and playful—she absolutely rocks on skis.',
    image: '/images/team/Tess-1280.webp',
    rotation: 'rotate(1.5deg)',
    instagram: '@tess_apex',
    email: 'tess@apexexperience.com'
  },
  {
    id: 'ignacio',
    name: 'Ignacio',
    role: 'Ski Instructor & CFO',
    candidMoment: 'First light fly fishing, then powder runs',
    handwrittenNote: 'Rivers are my meditation. Mountains are my therapy. Spreadsheets are my discipline.',
    story: '25+ years on skis and a fishing expert, he\'s a Canadian-certified ski instructor and a devoted outdoorsman. He also steps in as Apex\'s CFO when needed—bringing sharp financial discipline to bold mountain plans.',
    bio: '25+ years on skis and a fishing expert, he\'s a Canadian-certified ski instructor and a devoted outdoorsman. He also steps in as Apex\'s CFO when needed—bringing sharp financial discipline to bold mountain plans.',
    image: '/images/team/ignacio-1280.webp',
    rotation: 'rotate(-1deg)',
    instagram: '@ignacio_apex',
    email: 'ignacio@apexexperience.com'
  },
  {
    id: 'inaqui',
    name: 'Inaqui',
    role: 'Heli Guide & Pro Snowboarder',
    candidMoment: 'Dropping into untouched Andean spines',
    handwrittenNote: 'Competition taught me precision—the backcountry taught me soul',
    story: 'Our heli guide and one of Chile\'s most decorated snowboarders—multiple national titles, international podiums across South America and Europe, and World Cup circuit experience. He brings fearless backcountry lines, contest-proven precision, and deep Andes knowledge to every mission.',
    bio: 'Our heli guide and one of Chile\'s most decorated snowboarders—multiple national titles, international podiums across South America and Europe, and World Cup circuit experience. He brings fearless backcountry lines, contest-proven precision, and deep Andes knowledge to every mission.',
    image: '/images/team/Inaqui-1280.webp',
    rotation: 'rotate(2deg)',
    instagram: '@inaqui_apex'
  },
  {
    id: 'mati',
    name: 'Mati',
    role: 'Mountain Specialist',
    candidMoment: 'Sharing mountain stories after epic days',
    handwrittenNote: 'Every mountain has a story—I help you write yours',
    story: 'Coming soon—meet another exceptional member of our mountain team.',
    bio: 'Coming soon—meet another exceptional member of our mountain team.',
    image: 'https://images.unsplash.com/photo-1551632811-561732d1e306?w=800&q=80',
    rotation: 'rotate(-1.5deg)'
  }
]

export function getTeamMemberById(id: string): TeamMember | undefined {
  return teamMembers.find(member => member.id === id)
}

export function getTeamMembersByRole(role: string): TeamMember[] {
  return teamMembers.filter(member => member.role.toLowerCase().includes(role.toLowerCase()))
}
